import './IonicPageWrapper.css';
import { IonButtons, IonNavLink, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from "@ionic/react"
import { Preferences } from '@capacitor/preferences';
import { useHistory } from 'react-router';
// ICONs & SVGs
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import MoveUpIcon from "@mui/icons-material/MoveUp";

function IonicPageWrapper({ showMenuBtn, onBackClick, headerTitle, hideHeader, showLogout, children, showClassUpgrade, onClassUpgradeClick }) {
    const history = useHistory();

    const onLogoutClick = async () => {
        // await Preferences.remove({ key: 'gjaai_user_schoolid' });
        await Preferences.remove({ key: 'gjaii_IDCARD_user' });

        history.push('/signup')
    }

    return (
      <IonPage>
        {!hideHeader && (
          <IonHeader mode="ios" className="ion-no-border customIonic_header">
            <IonToolbar mode="ios" className="customIonic_toolbar">
              {showMenuBtn && (
                <IonButtons slot="start">
                  <IonMenuButton />
                </IonButtons>
              )}
              {onBackClick && (
                <IonNavLink
                  slot="start"
                  onClick={onBackClick}
                  routerDirection="back"
                  className="customIonic_header_backBtn"
                >
                  <ArrowBackIosRoundedIcon
                    style={{ fontSize: 20, color: "#dfdfdf" }}
                  />
                  Back
                </IonNavLink>
              )}
              <IonTitle>{headerTitle}</IonTitle>

              {showLogout && (
                <IonButtons slot="end" onClick={onLogoutClick}>
                  <PowerSettingsNewIcon
                    style={{ fontSize: 27, color: "#fff", marginRight: 5 }}
                  />
                </IonButtons>
              )}

              {showClassUpgrade && (
                <IonButtons slot="end" onClick={onClassUpgradeClick}>
                  <MoveUpIcon
                    style={{ fontSize: 27, color: "#fff", marginRight: 5 }}
                  />
                </IonButtons>
              )}
            </IonToolbar>
          </IonHeader>
        )}

        <IonContent fullscreen className="customIonic_ionContent">
          {children}
        </IonContent>
      </IonPage>
    );
}

export default IonicPageWrapper